import React from 'react'
import { makeStyles } from '@material-ui/core'
import { PageMetatags, PageContent, Spinner } from 'components'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    padding: 0,
    height: 'auto',
  },
  content: {
    position: 'relative',
    margin: '40px 0',
    height: '100%',
    width: '100%',
    maxWidth: '1024px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  fullscreen: {
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    margin: '0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentFullscreen: {
    width: '100%',
    height: '100%',
    margin: '0',
  }
}))



export type PageProps = {
  isLoading?: boolean
  className?: string
  title: string
  fullscreen?: boolean
  parameters?: { [key: string]: string }
  previousRoute?: string
  currentRoute?: string
  children?: React.ReactNode
}

const Page = ({ ...props }: PageProps) => {
  const classes = useStyles()

  const [isLoading, setIsLoading] = React.useState(props.isLoading ?? false)


  React.useEffect(() => {
    let initialized = true
    setIsLoading(!initialized)
  }, [])


  //RENDER

  if (isLoading === true) {
    return (
      <div className={classes.loading} >
        <Spinner />
      </div>
    )
  }


  return (
    <div className={props.fullscreen === true ? clsx(classes.root, classes.fullscreen) : classes.root}>
      <PageMetatags title={props.title} parameters={props.parameters} />

      <PageContent className={props.fullscreen === true ? clsx(classes.content, classes.contentFullscreen) : clsx(classes.content)}>
        {props.children}
      </PageContent>
    </div >
  )
}

export default Page
